export default "__VITE_ASSET__DvqltBYG__"